import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import _ from 'lodash';
import FrameMessages from '../const/FrameMessages';
import {renderModes} from '../const/AugmentationConst';

export const IFRAME_AD_POPUP_DELAY = 3000;

export default class ModalOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      overlayVisible: false,
    };
    this.canSkip = false;
  }

  componentDidMount() {
    const {renderMode} = this.props;
    if (renderMode === renderModes.iframeVupopup) {
      setTimeout(() => this.setState({overlayVisible: true}), IFRAME_AD_POPUP_DELAY);
    } else {
      this.setState({overlayVisible: true});
    }
  }

  initOverlay() {
    window.addEventListener('keydown', this.closeOnEscape);
    window.addEventListener('message', this.handleFrameMessage);

    const {skipTimeout, renderMode} = this.props;
    if (skipTimeout > 0) {
      if (renderMode !== renderModes.iframeVupopup) {
        setTimeout(() => {
          this.canSkip = true;
        }, skipTimeout * 1000);
      }
    } else {
      this.canSkip = true;
    }
  }

 componentDidUpdate(prevProps, prevState) {
   const overlayVisible = !prevState.overlayVisible && this.state.overlayVisible;
   if (overlayVisible) {
     this.initOverlay();
   }
 }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.closeOnEscape);
    window.removeEventListener('message', this.handleFrameMessage);
  }

  @autobind
  handleFrameMessage(e) {
    const title = _.get(e, 'data.title');
    const frameId = _.get(e, 'data.frameId');
    if (title === FrameMessages.allowDismiss && frameId && frameId === this.props.frameId) {
      this.canSkip = true;
    }
  }

  @autobind
  closeOnEscape(e) {
    if (e.keyCode === 27) {
      this.onClose();
    }
  }

  render() {
    const {children, rendererId} = this.props;
    const {overlayVisible} = this.state;

    if (!overlayVisible) {
      return null;
    }

    return (
      <div className="vuCard-overlay"
           id="vuCard-overlay"
           data-renderer-id={rendererId}
           onClick={this.onOverlayClick}
           ref={(elem) => {
            this.overlay = elem;
          }}
      >
        {children}
      </div>
    );
  }

  @autobind
  onClose() {
    if (this.canSkip) {
      this.props.onClose();
    }
  }

  @autobind
  onOverlayClick(e) {
    if (e.target === this.overlay) {
      this.onClose();
    }
  }
}

ModalOverlay.displayName = 'ModalOverlay';
ModalOverlay.propTypes = {
  rendererId: PropTypes.number,
  renderMode: PropTypes.string,
  frameId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  showSkipSection: PropTypes.bool,
  skipTimeout: PropTypes.number
};

ModalOverlay.defaultProps = {
  showSkipSection: false,
  skipTimeout: 0,
  renderMode: null,
  frameId: null,
};
